export const LOGIN_ROUTE = "/login";

export const HOME_ROUTE = "/";

export const USERS_ROUTE = "/users";

export const SUPERVISIONS_ROUTE = "/supervisions";

export const SUPERVISION_NODES_ROUTE = "/supervisionnodes";
